const ACTION = 'MATCHED_ITEMS_MERCHANT_REMOVE';

const actionCreator = payload => ({ type: ACTION, payload });

actionCreator.ACTION = ACTION;

export default actionCreator;


// WEBPACK FOOTER //
// ./src/Menu/ActionCreator/removeMatchedItemsByMerchantAction.js